/* eslint-disable no-console */
import _ from 'underscore';
import Glide from '../../vendors/glide.min';
import { getItemsFromAccount, removeItemFromAccount } from '../consumer-account/storage-actions';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

// Swatch and photo image item templates
const template =
  `<div class="col d-flex">
    <div class="scene-item" id="scene-id-{{ assetId }}">
      <div class="scene-item-inner">
        <div class="scene-item-images">
          <div class="glide scene-item-slider" data-asset-id="{{ assetId }}">
            <div class="glide">
              <div class="glide__track view-scene-details-btn" data-glide-el="track" data-asset-id="{{ assetId }}">
                <ul class="glide__slides">
                  {{ addSlides(photos) }}
                </ul>
              </div>
              <div class="glide__arrows lg-actions hidden" data-glide-el="controls">
                <button class="glide__arrow glide__arrow--left lg-icon lg-prev" data-glide-dir="<"></button>
                <button class="glide__arrow glide__arrow--right lg-icon lg-next" data-glide-dir=">"></button>
              </div>
            </div>
          </div>
        </div>
        <div class="scene-item-details py-4 px-2">
          <div class="item-details heading-xs mb-1">{{ photos.length }} Photo{{ (photos.length > 1 ? 's' : '') }}<span class="body-xs">&nbsp;&bull;&nbsp;</span>Updated {{ date }}</div>
          <div class="item-actions">
            <a href="/visualization/?minimal&Brand=Bali&fetch={{ sessionUrl }}" class="more-link pr-3">Edit in Visualizer</a>
            <button class="more-link view-scene-details-btn" data-asset-id="{{ assetId }}">+ View Details</button>
          </div>
        </div>  
      </div>
    </div>
  </div>`;

const noItemsTemplate =
  `<div class="row">
    <div class="col">
      <div class="rounded-box bg-gray p-5">
        {{ content }}
      </div>
    </div>
  </div>`;

const modalTemplate =
  `<div class="modal modal-visible" id="modal-{{ assetId }}" tabindex="0" aria-label="Visualization Scene Modal">
    <div class="modal-overlay"></div>
    <div class="modal-panel">
      <button type="button" class="close-btn" aria-label="Close Modal"></button>
      <div class="modal-inner">
        <div class="modal-content">
        <div class="container-fluid">
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="scene-item-images">
                <div class="glide scene-item-slider" data-asset-id="{{ assetId }}">
                  <div class="glide">
                    <div class="glide__track view-scene-details-btn" data-glide-el="track" data-asset-id="{{ assetId }}">
                      <ul class="glide__slides">
                        {{ addSlides(photos) }}
                      </ul>
                    </div>
                    <div class="glide__arrows lg-actions hidden" data-glide-el="controls">
                      <button class="glide__arrow glide__arrow--left lg-icon lg-prev" data-glide-dir="<"></button>
                      <button class="glide__arrow glide__arrow--right lg-icon lg-next" data-glide-dir=">"></button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="scene-item-details-wrapper clearfix">
                <h4 class="m-b-xxs">Products Featured</h4>
                <div class="scene-item-details"></div>
              </div>
              <div class="scene-item-share-wrapper">
                <h4 class="m-b-xxs">Share this Image</h4>
                <div>
                  <a href="" class="link m-r-xxs" id="scene-share-fb" target="_blank">Facebook</a>
                  <a href="" class="link m-r-xxs" id="scene-share-tw" target="_blank">Twitter</a>
                  <a href="" class="link m-r-xxs" id="scene-share-pt" target="_blank">Pinterest</a>
                  <a href="" class="link" id="scene-share-em" target="_blank">Email</a>
                </div>
              </div>
              <div class="scene-item-actions">
                <button class="favorites-item-btn toggle-remove-confirmation-btn">
                  <span>
                    <div class="remove-item-btn-icon">
                      <div class="icon"></div>
                    </div>
                    <div class="favorites-item-btn-label">Remove from My Favorites</div>
                  </span>
                </button>
                <div class="remove-scene-confirmation hidden">
                  <p class="body--small">All photos and data contained in this visualizer scene will be deleted. Do you still want to continue?</p>
                  <div class="confirmation-actions">
                    <button class="action-link white border-white update-swatchbook-btn m-r-xxs" data-asset-id="{{ assetId }}">Yes</button>
                    <button class="action-link border-white confirmation-no-btn">No</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;

const getTwitterShareUrl = options => (
  `https://twitter.com/intent/tweet?text=${options.message}&url=${options.url}`
);

const getFacebookShareUrl = options => (
  `https://www.facebook.com/sharer/sharer.php?u=${options.url}`
);

const getPintrestShareUrl = options => (
  `https://pinterest.com/pin/create/button/?url=${options.url}&media=${options.imgUrl}&description=${options.caption}`
);

const getEmailShareUrl = options => (
  `mailto:?subject=${options.message}&body=Photo%20link%3A%20${options.url}%0A%0AAbout%20this%20photo%3A%20'${options.caption}`
);

const templateVals = _.template(template);
const noItemsTemplateVals = _.template(noItemsTemplate);
const modalTemplateVals = _.template(modalTemplate);
const modal = document.querySelector('.visualization-modal-container');
let items = [];

const props = {
  enqueuePdfUtilsData: null,
  getItemById: null,
  updateSwatchbook: null,
};

const hasItems = () => (
  items.length !== 0
);

const update = () => {
  const { NoVisualizationsContent } = window;
  const div = document.createElement('div');
  const selector = document.querySelector('.visualizer-scenes-content');
  if (items.length === 0) {
    const compiled = noItemsTemplateVals({
      content: NoVisualizationsContent,
    });
    div.innerHTML = compiled;
    selector.innerHTML = '';
    selector.appendChild(div.firstChild);
  }
  props.updateSwatchbook();
};

const toggleRemoveConfirmationHandler = () => {
  const div = modal.querySelector('.remove-scene-confirmation');
  if (div.classList.contains('hidden')) {
    div.classList.remove('hidden');
  } else {
    div.classList.add('hidden');
  }
};

const removeButtonHandler = (event) => {
  const btn = event.target;
  const assetId = btn.getAttribute('data-asset-id');
  removeItemFromAccount('visualization', assetId, () => {
    const photo = document.getElementById(`scene-id-${assetId}`);
    photo.parentNode.removeChild(photo);
    props.removePageItemById(items, assetId);
    modal.querySelector('.confirmation-no-btn').removeEventListener('click', toggleRemoveConfirmationHandler);
    modal.querySelector('.toggle-remove-confirmation-btn').removeEventListener('click', toggleRemoveConfirmationHandler);
    modal.querySelector('.update-swatchbook-btn').removeEventListener('click', removeButtonHandler);
    modal.removeChild(modal.firstChild);
    document.removeEventListener('click', removeModal); /* eslint-disable-line no-use-before-define */
    update();
  });
};

const removeModal = (event) => {
  let isModalRemoved = false;
  if (modal.firstChild !== null) {
    if (event.target.classList.contains('modal') && event.target.classList.contains('modal-visible')) {
      isModalRemoved = true;
    } else if (event.target.classList.contains('close-btn') || event.target.classList.contains('modal-overlay')) {
      isModalRemoved = true;
    }
    if (isModalRemoved) {
      modal.querySelector('.confirmation-no-btn').removeEventListener('click', toggleRemoveConfirmationHandler);
      modal.querySelector('.toggle-remove-confirmation-btn').removeEventListener('click', toggleRemoveConfirmationHandler);
      modal.querySelector('.update-swatchbook-btn').removeEventListener('click', removeButtonHandler);
      modal.removeChild(modal.firstChild);
      document.removeEventListener('click', removeModal);
    }
  }
};

const updatePhotoDetails = (item) => {
  const div = modal.querySelector('.scene-item-details');
  const productData = item.photos[item.activeScene].products[0];
  let s = `<h5>${productData.name}</h5><p>`;
  productData.options.forEach((option) => {
    s += `${option}<br />`;
  });
  div.innerHTML = `${s}</p>`;
};

const updatePhotoShares = (item) => {
  const imgSrc = item.photos[item.activeScene].src;
  const imgId = imgSrc.substring(imgSrc.lastIndexOf('_') + 1, imgSrc.lastIndexOf('.'));
  let caption = `${item.photos[item.activeScene].products[0].name} - `;

  item.photos[item.activeScene].products[0].options.forEach((option, index) => {
    if (index !== 0) {
      caption += ', ';
    }
    caption += option;
  });

  modal.querySelector('#scene-share-tw').setAttribute('href', getTwitterShareUrl({
    message: 'Check out this photo I created using the Bali Product Visualizer',
    url: encodeURIComponent(`${window.visualizationPageUrl.replace(/&amp;/gi, '&')}&vissrcid=${imgId}`),
  }));

  modal.querySelector('#scene-share-fb').setAttribute('href', getFacebookShareUrl({
    url: encodeURIComponent(`${window.visualizationPageUrl.replace(/&amp;/gi, '&')}&vissrcid=${imgId}`),
  }));

  modal.querySelector('#scene-share-pt').setAttribute('href', getPintrestShareUrl({
    url: item.photos[item.activeScene].src,
    imgUrl: item.photos[item.activeScene].src,
    caption,
  }));

  modal.querySelector('#scene-share-em').setAttribute('href', getEmailShareUrl({
    message: 'Check%20out%20this%20photo%20I%20created%20using%20the%20Bali%20Product%20Visualizer',
    url: item.photos[item.activeScene].src,
    caption,
  }));
};

const initSlider = (options) => {
  const {
    div,
    assetId,
    isModal,
  } = options;
  const item = props.getItemById(items, assetId);
  const slider = new Glide(div, {
    direction: 'rtl',
    startAt: item.activeScene,
    type: 'carousel',
  }).mount();
  slider.on('run.after', () => {
    item.activeScene = slider.index;
    if (isModal) {
      updatePhotoDetails(item);
      updatePhotoShares(item);
    }
  });
};

const addModal = (data) => {
  // Add Modal
  const div = document.createElement('div');
  const compiled = modalTemplateVals(data);
  div.innerHTML = compiled;
  modal.appendChild(div.firstChild);
  document.addEventListener('click', removeModal);
  // Add Slider
  const slider = document.querySelector('.visualization-modal-container .scene-item-slider');
  if (slider.querySelectorAll('.glide__slide').length > 1) {
    initSlider({
      div: slider,
      assetId: slider.getAttribute('data-asset-id'),
      isModal: true,
    });
    slider.querySelector('.glide__arrows').classList.remove('hidden');
  }
  // Load First Photo Details/Share Links
  updatePhotoDetails(data);
  updatePhotoShares(data);
  // Add Remove Visualization Events
  modal.querySelector('.confirmation-no-btn').addEventListener('click', toggleRemoveConfirmationHandler);
  modal.querySelector('.toggle-remove-confirmation-btn').addEventListener('click', toggleRemoveConfirmationHandler);
  modal.querySelector('.update-swatchbook-btn').addEventListener('click', removeButtonHandler);
};

const addEventHandlers = () => {
  if (document.querySelectorAll('.visualization-modal-container .view-scene-details-btn')) {
    [].map.call(document.querySelectorAll('.view-scene-details-btn'), btn => btn.addEventListener('click', () => {
      const assetId = btn.getAttribute('data-asset-id');
      const item = props.getItemById(items, assetId);
      addModal(item);
    }));
  }
};

const addSliders = () => {
  const sliders = document.querySelectorAll('.visualizer-scenes-content .scene-item-slider');
  for (let i = 0; i < sliders.length; i++) { /* eslint-disable-line no-plusplus */
    if (sliders[i].querySelectorAll('.glide__slide').length > 1) {
      initSlider({
        div: sliders[i],
        assetId: sliders[i].getAttribute('data-asset-id'),
        isModal: false,
      });
      sliders[i].querySelector('.glide__arrows').classList.remove('hidden');
    }
  }
};

const mapVisualizationProductData = (productData) => {
  const products = [];
  const optionsData = productData[0].client_options[0].options;
  // Only grab the first item in productData for now...
  const product = {
    name: productData[0].client_options[0].options[0]['option-attributes'].programFamilyDescription,
    options: optionsData
      .filter(item => !item['is-filter'])
      .map((item) => {
        const optionName = `${item['option-friendly-name']}: ${item['option-friendly-value']}`;
        let colorNumber = '';
        if (item['option-friendly-name'].toLowerCase().indexOf('color') !== -1) {
          colorNumber = ` (${item['option-value']})`;
        }
        return `${optionName}${colorNumber}`;
      }),
  };
  products.push(product);
  return products;
};

const formatVisualizationProducts = (products) => {
  const productName = `${products[0].name}\n`;
  const productStyles = products[0].options.join('\n');
  return `${productName}${productStyles}`;
};

const onLoaded = (data) => {
  // Map data
  const pdfData = [];
  let imgNum = -1;
  items = data.visualizations.map((visualization) => {
    const date = new Date(visualization['last-updated']);
    const scene = {
      activeScene: 0,
      assetId: visualization.id,
      id: visualization.id,
      date: `${(date.getMonth() + 1)}/${date.getDate()}/${date.getFullYear()}`,
      sessionUrl: visualization['session-url'],
      photos: visualization.favourites.map((favourite) => {
        imgNum += 1;
        const products = mapVisualizationProductData(favourite.window_covers);
        // Add to pdfutils array
        pdfData.push({
          description: formatVisualizationProducts(products),
          id: `fvt${imgNum}`,
          imgsrc: favourite['thumbnail-url'],
          type: 'visualization',
        });
        return {
          id: `fvt${imgNum}`,
          src: favourite['thumbnail-url'],
          products,
        };
      }),
      addSlides: (slides) => {
        let s = '';
        slides.forEach((slide) => {
          s += `<li class="glide__slide">
            <div class="object-fit">
              <img src="${slide.src}" alt="" />
            </div>
          </li>`;
        });
        return s;
      },
    };
    return scene;
  });
  // Display saved content
  if (items.length > 0) {
    const selector = document.querySelector('.visualizer-scenes-content');
    const div = document.createElement('div');
    div.classList = 'row row-cols-sm-2 row-cols-lg-3';
    selector.innerHTML = '';
    items.forEach((item) => {
      const itemDiv = document.createElement('div');
      const compiled = templateVals(item);
      itemDiv.innerHTML = compiled;
      div.appendChild(itemDiv.firstChild);
    });
    selector.appendChild(div);
  }
  props.enqueuePdfUtilsData(pdfData);
  update();
  addEventHandlers();
  addSliders();
};

const init = (options) => {
  const {
    enqueuePdfUtilsData,
    getItemById,
    removePageItemById,
    updateSwatchbook,
  } = options;
  props.enqueuePdfUtilsData = enqueuePdfUtilsData;
  props.getItemById = getItemById;
  props.removePageItemById = removePageItemById;
  props.updateSwatchbook = updateSwatchbook;
  getItemsFromAccount('visualization', onLoaded);
};

export {
  hasItems,
  init,
  onLoaded,
};
/* eslint-enable no-console */
